import React, { useState } from 'react';
import Button from 'packages/ui/Button';
import { IconButton } from 'routes/events/utils/FeatureButton';
import FontIcon from 'packages/ui/FontIcon';
import styled from 'styled-components';
import { api } from 'app';

export default function Report({ campaignId }) {
  const [formValues, setFormValues] = useState([
    { name: 'تعداد کل ارسال', value: '' },
    { name: 'تعداد موفق ارسال', value: '' },
    { name: 'درصد کلیک', value: '' }
  ]);

  const handleSubmit = event => {
    event.preventDefault();
    api
      .post(`/advertising-campaigns/${campaignId}/statistics`, {
        data: formValues
      })
      .then(res => {});
  };

  const handleChange = (i, e) => {
    const newFormValues = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFormValues(newFormValues);
  };

  const addFormFields = () => {
    setFormValues([...formValues, { name: '', value: '' }]);
  };

  const removeFormFields = i => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  const AnchorIcon = styled(FontIcon)`
    cursor: pointer;
  `;

  return (
    <>
      <h3 className="text-center">گزارش تبلیغات به برگزارکننده</h3>
      <form onSubmit={handleSubmit}>
        {formValues.map((element, index) => (
          <div className="d-flex" key={index}>
            <div className="w-100">
              <input
                type="text"
                className="form-control"
                name="name"
                value={element.name || ''}
                onChange={e => handleChange(index, e)}
              />
            </div>
            <div className="w-100">
              <input
                type="text"
                className="form-control"
                name="value"
                value={element.value || ''}
                onChange={e => handleChange(index, e)}
              />
            </div>
            <IconButton
              handleClick={() => removeFormFields(index)}
              mood="tertiary"
              iconName="remove"
              fontSize="20px"
            />
          </div>
        ))}
        <div className="d-flex">
          <AnchorIcon name="plus-mark" size="20px" onClick={() => addFormFields()} />
        </div>
        <div className="d-flex justify-content-center">
          <Button type="submit" onClick={handleSubmit}>
            ارسال گزارش
          </Button>
          <Button type="button" mood="secondary" className="me-5">
            مشاهده پنل
          </Button>
        </div>
      </form>
    </>
  );
}
